// styles.js
export const baseWrapperStyle = {
  position: "fixed",
  zIndex: 9999,
  pointerEvents: "none",
  display: "flex",
};

export const toastStyle = {
  width: "100%",
  maxWidth: 640, // ocupa mais a tela
  padding: "12px 20px",
  borderRadius: 12,
  backgroundColor: "#275224", // verde pedido
  color: "#fff",
  fontSize: 14,
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
  display: "flex",
  alignItems: "center",
  gap: 12,
  transition: "opacity 0.6s ease",
  pointerEvents: "auto",
};

export const spinnerStyle = {
  width: 18,
  height: 18,
  borderRadius: "50%",
  border: "2px solid rgba(255,255,255,0.4)",
  borderTopColor: "#ffffff",
  animation: "spin 0.8s linear infinite",
  flexShrink: 0,
};

export const messageStyle = {
  lineHeight: 1.4,
};
